export const ReplacingProximitySensor = ({
  height = 100,
  width = 100,
}: {
  height?: number;
  width?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_b_2954_9181)">
        <circle cx="50" cy="50" r="50" fill="#ebebeb" fillOpacity="0.5" />
      </g>
      <path
        d="M50 69.9375C45.0019 69.9375 40.2677 68.0633 36.6226 64.7523L34.204 67.171C33.9441 67.4308 33.5 67.2466 33.5 66.8795V58.6625C33.5 58.4342 33.6843 58.25 33.9125 58.25H42.1295C42.4966 58.25 42.6809 58.6941 42.421 58.954L39.5431 61.8318C42.4155 64.3728 46.1046 65.8125 50 65.8125C59.614 65.8125 67.1174 57.2256 65.6269 47.5648C65.4536 46.4401 66.225 45.3868 67.3511 45.2122C68.469 45.0362 69.5291 45.8103 69.7038 46.9365C71.582 59.0832 62.1426 69.9375 50 69.9375Z"
        fill="#262626"
      />
      <path
        d="M32.6489 54.7878C31.5393 54.9638 30.4709 54.2006 30.2963 53.0635C28.418 40.9168 37.8574 30.0625 50 30.0625C54.9981 30.0625 59.7323 31.9366 63.3774 35.2476L65.796 32.829C66.0559 32.5691 66.5 32.7534 66.5 33.1205V41.3375C66.5 41.5658 66.3158 41.75 66.0875 41.75H57.8705C57.5034 41.75 57.3191 41.3059 57.579 41.046L60.4569 38.1681C57.5859 35.6271 53.8954 34.1875 50 34.1875C40.386 34.1875 32.8826 42.7744 34.3731 52.4351C34.5478 53.5613 33.775 54.6145 32.6489 54.7878Z"
        fill="#262626"
      />
      <path
        d="M59.218 44.2388L56.963 44.7916C56.809 44.8287 56.6509 44.7737 56.5505 44.6499C55.8671 43.8126 55.0751 43.1471 54.1319 42.6204C53.993 42.5434 53.9105 42.3977 53.9215 42.2396L54.0741 39.9227C54.0879 39.7123 53.9407 39.5253 53.7345 39.4896L50.088 38.8461C49.8804 38.8089 49.6796 38.9354 49.6205 39.1376L48.9687 41.3747C48.9247 41.5259 48.7982 41.6332 48.6429 41.6593C47.6047 41.8271 46.5941 42.1818 45.6701 42.7318C45.5354 42.8116 45.369 42.8116 45.2384 42.7236L43.3092 41.4338C43.1346 41.3169 42.8995 41.3499 42.7634 41.5122L40.3832 44.3488C40.2485 44.5097 40.2554 44.7476 40.4011 44.8988L42.0057 46.5736C42.1144 46.6863 42.1432 46.8513 42.0882 46.9971C41.7074 48.0008 41.5327 49.0582 41.5492 50.1101C41.552 50.2668 41.4667 50.4112 41.3265 50.4813L39.2365 51.5112C39.0481 51.6047 38.9587 51.8247 39.0316 52.0227L40.298 55.5014C40.3695 55.6994 40.5799 55.8108 40.7834 55.7613L43.0384 55.2086C43.1924 55.1714 43.3505 55.2264 43.4509 55.3502C44.1329 56.1876 44.9262 56.8531 45.8695 57.3797C46.0084 57.4567 46.0909 57.6024 46.0799 57.7606L45.9272 60.0774C45.9135 60.2878 46.0606 60.4748 46.2669 60.5106L49.9134 61.154C50.121 61.1912 50.3217 61.0647 50.3809 60.8626L51.0326 58.6254C51.0766 58.4742 51.2031 58.3669 51.3585 58.3408C52.398 58.1731 53.4072 57.8169 54.3312 57.2683C54.466 57.1886 54.6324 57.1886 54.763 57.2752L56.6907 58.5636C56.8654 58.6804 57.1005 58.6474 57.2366 58.4852L59.6167 55.6486C59.7515 55.4877 59.7446 55.2498 59.5989 55.0986L57.9942 53.4238C57.8856 53.3111 57.8567 53.1461 57.9117 53.0003C58.2926 51.9966 58.4672 50.9392 58.4507 49.8873C58.448 49.7306 58.5332 49.5862 58.6735 49.5161L60.7635 48.4862C60.9519 48.3927 61.0412 48.1727 60.9684 47.9747L59.702 44.4959C59.6319 44.3007 59.4215 44.1879 59.218 44.2388ZM51.4107 53.8748C49.2699 54.6544 46.9035 53.5503 46.1252 51.4094C45.3456 49.2686 46.4497 46.9022 48.5906 46.1239C50.7315 45.3443 53.0979 46.4484 53.8761 48.5893C54.6544 50.7302 53.5502 53.0966 51.4107 53.8748Z"
        fill="#262626"
      />
      <defs>
        <filter
          id="filter0_b_2954_9181"
          x="-24"
          y="-24"
          width="148"
          height="148"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="12" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_2954_9181"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_2954_9181"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
